var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"title":_vm.$t('zotero.tooltip'),"target":"_blank","href":_vm.zotero_item_url}},[_c('img',{staticClass:"service-icon",attrs:{"src":require("@/assets/img/zotero.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }